<script lang="ts">
    import ProductEntity from "@modules/products/entities/ProductEntity";
    import ProductVariantsEntity from "@modules/products/entities/ProductVariantsEntity";
    import { createEventDispatcher } from "svelte";

    import Dropdown from "@components/forms/Select/Dropdown.svelte";

    import { WishlistItemEntity } from "../entities/WishlistItemEntity";
    import { WishlistWithItemsEntity } from "../entities/WishlistWithItemsEntity";

    export let productOptions: {
        variantsMap: Record<string, number>;
        values: string[];
        name: string;
    }[];
    export let selectedOptions: Record<string, string>;
    export let productAndVariantInfo: {
        product: ProductEntity | undefined;
        variant: ProductVariantsEntity | undefined;
    };
    export let wishlist: WishlistWithItemsEntity;
    export let wishlistItem: WishlistItemEntity;

    const dispatch = createEventDispatcher();

    const handleUpdateItemVariant = (
        wishlistId: number,
        productId: number,
        variantId: number,
        newVariantId: number
    ) => {
        dispatch("updateItemVariant", {
            wishlistId,
            productId,
            oldVariantId: variantId,
            newVariantId,
        });
    };
</script>

<div class="gw-wl-page-item__editable-options-wrapper">
    {#each productOptions as productOption}
        <Dropdown
            selectClass="gw-wl-page-item__editable-select_options"
            items={productOption.values.map((value) => ({
                value,
                label: value,
            }))}
            value={selectedOptions[productOption.name]}
            on:change={(e) => {
                const newOptionValue = e.detail.value;
                const updatedOptions = {
                    ...selectedOptions,
                    [productOption.name]: newOptionValue,
                };

                const newVariant = productAndVariantInfo.product?.variants.find(
                    (variant) =>
                        variant.options.every(
                            (opt) => updatedOptions[opt.name] === opt.value
                        )
                );

                if (newVariant && newVariant.id !== wishlistItem.variantId) {
                    handleUpdateItemVariant(
                        wishlist.id,
                        wishlistItem.productId,
                        wishlistItem.variantId,
                        newVariant.id
                    );
                }
            }}
        />
    {/each}
</div>

<style lang="postcss">
    .gw-wl-page-item__editable-options-wrapper {
        display: flex;
        gap: 0.25em;
        margin: 0.5em 0 0.25em;

        @media screen and (max-width: 500px) {
            flex-direction: column;
        }

        :global(.gw-wl-page-item__editable-select_options.gw-select) {
            --input-border-radius: 0.25em;
            --listTop: 2em;
            padding: 0.25em;
            height: 2em;
            width: 100%;
        }

        :global(
                .gw-wl-page-item__editable-select_options.gw-select
                    .gw-select-list
            ) {
            min-width: 100%;
            width: auto;
            right: auto;
        }

        :global(
                .gw-wl-page-item__editable-select_options .gw-select__selected
            ) {
            display: none;
        }

        :global(.gw-wl-page-item__editable-select_options .gw-select__input) {
            --inputColor: currentColor;
            font-size: 0.75em;
            font-weight: 700;
            text-overflow: ellipsis;
        }
        :global(
                .gw-wl-page-item__editable-select_options .gw-select-item__btn
            ) {
            font-size: 0.75em;
            font-weight: 700;
        }
    }
</style>
